const CITIES: Readonly<Record<string, string>> = { astana: 'Астана', warsaw: 'Варшава' }

export function postCity(post: string): string {
  return CITIES[post] ?? post
}

export function shortId(id: string): string {
  return id.slice(0, 8)
}

/** Время по Астане: так его видит оператор и показывает кабинет посольства. */
export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Asia/Almaty',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso))
}

/** Сколько прошло: «6 мин», «2 ч 10 мин», «3 дн». */
export function elapsed(iso: string, now: Date = new Date()): string {
  const minutes = Math.max(0, Math.floor((now.getTime() - new Date(iso).getTime()) / 60_000))
  if (minutes < 1) return 'только что'
  if (minutes < 60) return `${minutes} мин`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return minutes % 60 === 0 ? `${hours} ч` : `${hours} ч ${minutes % 60} мин`
  return `${Math.floor(hours / 24)} дн`
}

export function ago(iso: string | null, now: Date = new Date()): string {
  if (iso === null) return 'никогда'
  const text = elapsed(iso, now)
  return text === 'только что' ? text : `${text} назад`
}

/** Тише, чем «мин»: секунды для пульса воркеров. */
export function agoShort(iso: string, now: Date = new Date()): string {
  const seconds = Math.max(0, Math.round((now.getTime() - new Date(iso).getTime()) / 1000))
  return seconds < 60 ? `${seconds} с назад` : ago(iso, now)
}

export function isOlderThan(iso: string, ms: number, now: Date = new Date()): boolean {
  return now.getTime() - new Date(iso).getTime() > ms
}
